export const API_PATCH_QUESTIONANSWER = 'API_PATCH_QUESTIONANSWER';
export const API_PATCH_QUESTIONANSWER_SUCCESS = 'API_PATCH_QUESTIONANSWER_SUCCESS';
export const API_PATCH_QUESTIONANSWER_FAIL = 'API_PATCH_QUESTIONANSWER_FAIL';

export const API_UPDATE_PI_QUESTIONANSWER = 'API_UPDATE_PI_QUESTIONANSWER';